enum PixLinkTypeEnum {
  Deal = 'D',
  Contract = 'C'
}

export default PixLinkTypeEnum
